import { CallToActionSplit } from "../../../../modules/content/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/content/components/CallToActionStacked/CallToActionStacked";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";

export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { anchorId, buttons, description, eyebrow, heading, image, parentClass, spacing, variant } =
    props;
  if (!eyebrow && !heading && !description && !buttons?.length && !image) return null;

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="border border-t-2 border-border border-t-primary px-6 py-10 md:px-12 md:py-14 lg:px-16 lg:py-16">
        {variant === "split" ? (
          <CallToActionSplit {...props} />
        ) : (
          <CallToActionStacked {...props} />
        )}
      </div>
    </DaylightSection>
  );
};

CallToActionBlock.displayName = "Block::CallToActionBlock";
